const tallmanMap = {
    // List based on Australian ACSQHC National Tall Man Lettering list and other common lists
    "amiodarone": "amiodarONE",
    "amlodipine": "amLODIPine",
    "apixaban": "aPIXaban",
    "atenolol": "aTENolol",
    "atomoxetine": "atoMOXetine",
    "atorvastatin": "atorvaSTATin",
    "azathioprine": "azaTHIOprine",
    "azithromycin": "azithroMYcin",
    "captopril": "captoPRIL",
    "carbamazepine": "carbaMAZepine",
    "carvedilol": "carveDILol",
    "cefaclor": "cefACLOR",
    "cefazolin": "ceFAZolin",
    "cefepime": "cefePIME",
    "cefotaxime": "cefoTAXime",
    "cefoxitin": "ceFOXitin",
    "ceftazidime": "cefTAZidime",
    "ceftriaxone": "cefTRIAXone",
    "celecoxib": "celeCOXib",
    "cephalexin": "cephaLEXin",
    "chlordiazepoxide": "chlorDIAZEPoxide",
    "chlorpromazine": "chlorproMAZINE",
    "chlorpropamide": "chlorproPAMIDE",
    "cimetidine": "cimetIDINE",
    "ciprofloxacin": "ciproFLOXacin",
    "citalopram": "ciTALopram",
    "clobazam": "clobaZAM",
    "clomipramine": "clomiPRAMINE",
    "clonazepam": "clonazePAM",
    "clonidine": "cloNIDine",
    "clopidogrel": "cloPIDogrel",
    "clozapine": "cloZAPine",
    "cyclobenzaprine": "cyclobenZAPRINE",
    "cyclosporine": "cycloSPORINE",
    "dabigatran": "daBIGatran",
    "desipramine": "desIPRAMINE",
    "dexamethasone": "dexaMETHasone",
    "diazepam": "diazePAM",
    "diclofenac": "diCLOFenac",
    "digoxin": "diGOXin",
    "diltiazem": "dilTIAZem",
    "diphenhydramine": "diphenhydraMINE",
    "dobutamine": "DOBUTamine",
    "donepezil": "donePEZil",
    "dopamine": "DOPamine",
    "dothiepin": "doTHIEpin",
    "doxazosin": "doxAZOsin",
    "doxepin": "DOXepin",
    "doxorubicin": "doxoRUBicin",
    "doxycycline": "doxyCYCLINE",
    "duloxetine": "duLOXetine",
    "enalapril": "enALapril",
    "ephedrine": "ePHEDrine",
    "epinephrine": "EPINEPHrine",
    "epirubicin": "epiRUBicin",
    "erythromycin": "erythroMYcin",
    "escitalopram": "esciTALopram",
    "esomeprazole": "esomePRAZOLE",
    "ezetimibe": "eZETimibe",
    "famotidine": "famoTIDINE",
    "felodipine": "feLODIPine",
    "fentanyl": "fentaNYL",
    "fluconazole": "fluCONAZOLE",
    "fluoxetine": "fluOXETine",
    "flupenthixol": "flupenTHIXol",
    "fluphenazine": "fluphenAZINE",
    "fluticasone": "flutiCASONE",
    "fluvoxamine": "fluVOXAMine",
    "gabapentin": "gabaPENTin",
    "glibenclamide": "glibenCLAMIDE",
    "gliclazide": "gliCLAZide",
    "glimepiride": "glimePIRIDE",
    "glipizide": "glipIZIDE",
    "glyburide": "glyBURIDE",
    "haloperidol": "haloPERIDOL",
    "heparin": "HEPArin",
    "hydralazine": "hyDRALAZINE",
    "hydrochlorothiazide": "hydrochloroTHIAZIDE",
    "hydrocortisone": "hydroCORTISONE",
    "hydromorphone": "HYDROmorphone",
    "hydroxyzine": "hydrOXYzine",
    "ibuprofen": "ibuPROFEN",
    "imipramine": "imiPRAMINE",
    "indapamide": "inDAPAMIDE",
    "indomethacin": "indoMETHACIN",
    "insulin": "inSULin",
    "irbesartan": "irbeSARTAN",
    "isoprenaline": "isoPRENaline",
    "isosorbide": "isoSORBIDE",
    "isotretinoin": "isoTRETINOIN",
    "ketoconazole": "ketoCONAZOLE",
    "ketoprofen": "ketoPROFEN",
    "ketorolac": "ketoROLAC",
    "labetalol": "laBETalol",
    "lamivudine": "lamiVUDINE",
    "lamotrigine": "laMOTRIGine",
    "lansoprazole": "lansoPRAZOLE",
    "latanoprost": "laTANoprost",
    "levetiracetam": "leveTIRACETAM",
    "levobupivacaine": "levoBUPIVAcaine",
    "levodopa": "levoDOPA",
    "levofloxacin": "levoFLOXacin",
    "levothyroxine": "levoTHYROXINE",
    "lisinopril": "liSINopril",
    "lithium": "LITHium",
    "loperamide": "loPERAMIDE",
    "loratadine": "loraTADINE",
    "lorazepam": "loraZEPAM",
    "losartan": "loSARTAN",
    "lovastatin": "lovaSTATIN",
    "medroxyprogesterone": "medroxyPROGESTERONE",
    "meloxicam": "melOXICAM",
    "metformin": "metFORMIN",
    "methadone": "METHadone",
    "methotrexate": "methoTREXATE",
    "methylphenidate": "methylPHENIDATE",
    "methylprednisolone": "methylPREDNISOLONE",
    "metoclopramide": "metoCLOPRAMIDE",
    "metoprolol": "metOPROLOL",
    "metronidazole": "metroNIDAZOLE",
    "midazolam": "midAZOLam",
    "mirtazapine": "mirTAZapine",
    "montelukast": "monteLUKAST",
    "morphine": "MORPHine",
    "mycophenolate": "mycoPHENOLATE",
    "naloxone": "nalOXone",
    "naltrexone": "nalTREXone",
    "naproxen": "naPROXen",
    "nefazodone": "neFAZodone",
    "nifedipine": "niFEDipine",
    "nimodipine": "niMODipine",
    "nitroglycerin": "nitroGLYCERIN",
    "nortriptyline": "norTRIPTYLINE",
    "olanzapine": "oLANZapine",
    "omeprazole": "omePRAZOLE",
    "ondansetron": "onDANsetron",
    "oxazepam": "oxAZEPAM",
    "oxybutynin": "oxyBUTYNIN",
    "oxycodone": "oxyCODONE",
    "oxycontin": "oxyCONTIN",
    "paclitaxel": "PACLItaxel",
    "pantoprazole": "pantoPRAZOLE",
    "paroxetine": "parOXETine",
    "penicillin": "peniCILLIN",
    "pentoxifylline": "pentoxiFYLLINE",
    "perindopril": "perINDOpril",
    "phenytoin": "phenyTOIN",
    "pioglitazone": "pioGLITAZONE",
    "piroxicam": "pirOXICAM",
    "potassium": "poTASSIUM",
    "pramipexole": "pramiPEXOLE",
    "pravastatin": "pravaSTATIN",
    "prazosin": "PRazosin",
    "prednisolone": "prednisoLONE",
    "prednisone": "predniSONE",
    "pregabalin": "preGABalin",
    "prochlorperazine": "prochlorPERAZINE",
    "promethazine": "proMETHAZINE",
    "propranolol": "proPRANOLOL",
    "quetiapine": "queTIApine",
    "quinapril": "quinAPRIL",
    "rabeprazole": "rabePRAZOLE",
    "ramipril": "raMIpril",
    "ranitidine": "raniTIDINE",
    "risperidone": "risPERIDONE",
    "rivaroxaban": "rivaROXaban",
    "ropinirole": "roPINIROLE",
    "ropivacaine": "roPIVAcaine",
    "rosuvastatin": "rosuvaSTATIN",
    "salbutamol": "salBUTamol",
    "salmeterol": "salMETEROL",
    "sertraline": "SERTraline",
    "simvastatin": "simvaSTATIN",
    "sitagliptin": "sitaGLIPTIN",
    "solifenacin": "soliFENACIN",
    "sotalol": "SOTalol",
    "spironolactone": "spironoLACTONE",
    "sucralfate": "suCRALFATE",
    "sulfamethoxazole": "sulfaMETHOXAZOLE",
    "sulfasalazine": "sulfaSALAZINE",
    "sulindac": "suLINDAC",
    "sumatriptan": "sumaTRIPTAN",
    "tacrolimus": "tacROLimus",
    "tamsulosin": "tamSULOSIN",
    "telmisartan": "telmiSARTAN",
    "temazepam": "teMAZEpam",
    "terazosin": "terAZOsin",
    "terbinafine": "terBINAFINE",
    "tiotropium": "tioTROPIUM",
    "tizanidine": "tiZANIDINE",
    "tolterodine": "tolTERODINE",
    "topiramate": "toPIRAMATE",
    "tramadol": "TRAMadol",
    "trazodone": "traZODONE",
    "valacyclovir": "valACYclovir",
    "valganciclovir": "valGANciclovir",
    "valproate": "VALproate",
    "valsartan": "valSARTAN",
    "venlafaxine": "venLAFAXine",
    "verapamil": "verAPAMIL",
    "warfarin": "WARfarin",
    "ziprasidone": "ziPRASIDONE",
    "zolmitriptan": "zolMITRIPTAN",
    "zolpidem": "ZOLPidem",
    "zopiclone": "ZOPiclone"
};

export function applyTallmanLettering(genericName) {
    if (!genericName) return '';
    
    // Ensure the input string is converted to string in case something else is passed
    const nameStr = String(genericName);
    
    // Convert to lowercase to match against the dictionary
    const lowerName = nameStr.toLowerCase();
    
    // Split the generic name into words and delimiters (like space, +, -, /)
    let words = lowerName.split(/(\s+|\+|-|\/)/);
    
    for (let i = 0; i < words.length; i++) {
        let word = words[i];
        if (tallmanMap[word]) {
            words[i] = tallmanMap[word];
        } 
    }
    
    return words.join('');
}

export function applyTallmanToPack(packName) {
    if (!packName) return '';
    
    const nameStr = String(packName);
    
    // Split the name while keeping delimiters including brackets and commas
    let words = nameStr.split(/(\s+|\+|-|\/|\(|\)|,)/);
    
    for (let i = 0; i < words.length; i++) {
        let wordLower = words[i].toLowerCase();
        if (tallmanMap[wordLower]) {
            words[i] = tallmanMap[wordLower];
        } 
        // If not in the map, the original case is maintained in words[i]
    }
    
    return words.join('');
}
